import { AuthSessionProvider } from "../../components/contexts/authSessionContext";
import { AppChromeProvider } from "../../components/contexts/appChromeContext";
import { BackNavigationProvider } from "../../components/contexts/backNavigationContext";
import { NitroContext } from "../../components/contexts/nitroContext";
import { PageTitleProvider } from "../../components/contexts/pageTitleContext";
import { NotificationContext } from "../../components/contexts/notificationContext";
import { PopupTooltipContext } from "../../components/contexts/popupTooltipContext";
import { PreviousLocationProvider } from "../../components/contexts/PreviousLocationContext.js";
import { VideoModalProvider } from "../../components/contexts/SimpleVideoModalContext.js";
import { UserManagerContext } from "../../components/contexts/userManagerContext";
import { VehiclePageIsPrint } from "../../components/contexts/vehiclePagePrintContext";
import { SubheaderPrintProvider } from "../../components/contexts/subheaderPrintContext";
import { WindowSize } from "../../components/contexts/windowSizeContext";
import { DisclaimersProvider } from "../../components/molecules/disclaimersV2/DisclaimersContext.js";
import { GlossaryTooltipProvider } from "../../components/molecules/Glossary/GlossaryContext.js";

export function AppProviders({
  children,
  nitroContextValues,
  vehiclePagePrintValue,
  windowSizeValue,
  userManagerContextValue,
  userManager,
  notificationContextValue,
  popupTooltipContextValue,
}) {
  return (
    <PageTitleProvider>
      <VideoModalProvider>
        <DisclaimersProvider>
          <PreviousLocationProvider>
            <VehiclePageIsPrint.Provider value={vehiclePagePrintValue}>
              <SubheaderPrintProvider>
                <BackNavigationProvider>
                  <WindowSize.Provider value={windowSizeValue}>
                    <UserManagerContext.Provider
                      value={userManagerContextValue}
                    >
                      <AuthSessionProvider>
                        <AppChromeProvider>
                          <GlossaryTooltipProvider>
                            <NotificationContext.Provider
                              value={notificationContextValue}
                            >
                              <NitroContext.Provider value={nitroContextValues}>
                                <PopupTooltipContext.Provider
                                  value={popupTooltipContextValue}
                                >
                                  {children}
                                </PopupTooltipContext.Provider>
                              </NitroContext.Provider>
                            </NotificationContext.Provider>
                          </GlossaryTooltipProvider>
                        </AppChromeProvider>
                      </AuthSessionProvider>
                    </UserManagerContext.Provider>
                  </WindowSize.Provider>
                </BackNavigationProvider>
              </SubheaderPrintProvider>
            </VehiclePageIsPrint.Provider>
          </PreviousLocationProvider>
        </DisclaimersProvider>
      </VideoModalProvider>
    </PageTitleProvider>
  );
}
